/**
 * 主要用于 拖拉拽页面和报表页面中, 卡片右上角 用于 重置或清除 表格排序的 图标
 */
import React from "react";
import { useIntl } from "umi";
import {Bubble, Dropdown, List} from "tea-component";
import SvgIcon from "@home/components/SvgIcon";

const TableSortIcon = (props: any) => {
  const { onReset, onClear, className, style, bubbleProps, dropdownProps, triggerLabel} = props;
  const { formatMessage } = useIntl();
  
  return (<Bubble dark content={formatMessage({id: 'dbl_common_sort'})} {...bubbleProps}>
    <Dropdown
      clickClose={true}
      boxClassName={'dbl-card-drag-operation-dropdown'}
      className={className}
      style={style}
      button={
        triggerLabel ? (
          <span className="dbl-card-preview-menu-inline-trigger">
            <SvgIcon
              className="table-analysis-icon"
              type="refresh-icon-type"
            />
            {triggerLabel}
          </span>
        ) : (
          <SvgIcon
            className="table-analysis-icon"
            type="refresh-icon-type"
          />
        )
      }
      appearance="pure"
      placement="bottom-end"
      {...dropdownProps}
    >
      <List type="option">
        <List.Item
          onClick={onReset}
        >
          {formatMessage({id: 'dbl_common_sort_reset'})}
        </List.Item>
        <List.Item
          onClick={onClear}
        >
          {formatMessage({id: 'dbl_common_sort_clear'})}
        </List.Item>
      </List>
    </Dropdown>
  </Bubble>);
};

export default TableSortIcon;